import { api } from "@/api"

export type SupervisorPinForm = {
  pin: string
}

export const updateSupervisorPin = async (
  newValue: SupervisorPinForm
): Promise<unknown> => {
  const { body } = await api.post<unknown>(
    `/change-supervisor-pin/`,
    {
      body: newValue,
    }
  )

  return body
}
